import { HTML_INPUT_DATE_FORMAT, HTML_INPUT_TIME_FORMAT } from '@/mixins/js_config.js'

export default {
  /**
   * 最近的30天(按参数格式化)
   *
   * @param {string} isoTime 标准 iso 时间格式
   * @returns {object} moment 时间
   */
  moment(isoTime) {
    return moment(isoTime, HTML_INPUT_TIME_FORMAT).clone()
  },
  /**
   * 最近的30天(按参数格式化)
   *
   * @param {number} days 最近的天数
   * @returns {string} 时间范围
   */
  latestDaysParam(days) {
    let currentDay = moment().format(HTML_INPUT_DATE_FORMAT)
    let last30Day = moment()
      .subtract(days, 'days')
      .format(HTML_INPUT_DATE_FORMAT)

    return `${last30Day}~${currentDay}`
  },
  /**
   * 最近的30天(按参数格式化)
   *
   * @param {number} days 最近的天数
   * @returns {Array} 时间范围
   */
  latestDays(days) {
    let currentDay = moment().endOf('day')
    let beforeDay = moment()
      .subtract(days, 'days')
      .startOf('day')

    return [beforeDay, currentDay]
  },

  /**
   * 最近的一年(按参数格式化)
   *
   * @param {number} years 最近的年数
   * @returns {Array} 时间范围
   */
  latestYearsParam(years) {
    let currentDay = moment().format(HTML_INPUT_DATE_FORMAT)
    let beforeDay = moment()
      .subtract(years, 'years')
      .startOf('day')
      .format(HTML_INPUT_DATE_FORMAT)

    return `${beforeDay}~${currentDay}`
  },

  /**
   * 格式化为 YYYY-MM-DD HH:mm:ss
   *
   * @param {object} momentTime 时间
   * @returns {string} 格式化后的时间
   */
  formatDateTime(momentTime) {
    return momentTime.format('YYYY-MM-DD HH:mm:ss')
  },

  /**
   * 格尔化用于请求中参数，需要增加时区
   * 格式化为 YYYY-MM-DD HH:mm:ss+08:00
   *
   * @param {object} momentTime 时间
   * @returns {string} 格式化后的时间
   */
  formatDateTimeParam(momentTime) {
    return momentTime.format('YYYY-MM-DD HH:mm:ss+08:00')
  },

  /**
   * 计算从现在开始的时间
   *
   * @param {object} momentTime 时间
   * @returns {string} 格式化后的时间
   */
  fromNow(momentTime) {
    return momentTime.locale('zh-cn').fromNow()
  }
}
